var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.movimiento_caja.sale)?_c('b-button',{on:{"click":function($event){$event.stopPropagation();return _vm.show_sale.apply(null, arguments)}}},[_vm._v(" Venta N° "+_vm._s(_vm.movimiento_caja.sale.num)+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.concepto)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }